import * as React from 'react';



export default class LeaderboardMenu extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
     <svg  className={this.props.className} id="leaderboardMenu"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="12.5244" y1="21.469" x2="12.5244" y2="17.469" stroke="#F3F5F6" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="7.94141" y1="21.469" x2="7.94141" y2="20.219" stroke="#F3F5F6" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M17.1079 21.469L17.1079 14.9057" stroke="#F3F5F6" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M2.27441 2.05225V22.2189H21.7254V12.8314" stroke="#F3F5F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.33246 16.0991C6.03957 16.392 6.03957 16.8668 6.33246 17.1597C6.62536 17.4526 7.10023 17.4526 7.39312 17.1597L6.33246 16.0991ZM22.4614 1.78084C22.4614 1.36662 22.1256 1.03084 21.7114 1.03084L14.9614 1.03084C14.5471 1.03084 14.2114 1.36662 14.2114 1.78084C14.2114 2.19505 14.5471 2.53084 14.9614 2.53084L20.9614 2.53084V8.53084C20.9614 8.94505 21.2971 9.28084 21.7114 9.28084C22.1256 9.28084 22.4614 8.94505 22.4614 8.53084V1.78084ZM6.86279 16.6294L7.39312 17.1597L22.2417 2.31117L21.7114 1.78084L21.181 1.25051L6.33246 16.0991L6.86279 16.6294Z" fill="#F3F5F6"/>
    </svg>

    )
  }
}
